import React from 'react';

interface IProps {
    name: string,
    placeholder?: string,
    value: string,
    onChange: any,
    disabled?: boolean
}

const TextArea = ({ placeholder, name, onChange, value, disabled = false }: IProps) => {
    return <textarea 
        className='form-control' 
        placeholder={placeholder}
        name={name}
        onChange={onChange}
        value={value}
        disabled={disabled}
    />
}

export default TextArea;